export const TEAM_SIZE_QUESTION = `How many people work at your company?`;
export const TYPE_OF_WORK_QUESTION = `What type of work do you do?`;
export const CURRENT_POSITION_QUESTION = `What's your current position?`;
export const HEARD_ABOUT_CLOCKWISE_QUESTION = `How did you hear about Clockwise?`;

export const QuestionType = {
  HowManyPeopleOnTeam: "HowManyPeopleOnTeam",
  WhatTypeOfWorkDoYouDo: "WhatTypeOfWorkDoYouDo",
  WhatIsYourCurrentPosition: "WhatIsYourCurrentPosition",
  HowDidYouHearAboutClockwise: "HowDidYouHearAboutClockwise",
};

export const ResponseType = {
  LessThan5: "LessThan5",
  Between5And9: "Between5And9",
  Between10And15: "Between10And15",
  Between15And20: "Between15And20",
  MoreThan20: "MoreThan20",
  IDoNotWorkOnAnyTeams: "IDoNotWorkOnAnyTeams",
  Administrative: "Administrative",
  AccountingOrFinance: "AccountingOrFinance",
  BusinessOwner: "BusinessOwner",
  CustomerSupport: "CustomerSupport",
  DesignOrUxResearch: "DesignOrUxResearch",
  SoftwareEngineering: "SoftwareEngineering",
  It: "It",
  Legal: "Legal",
  Marketing: "Marketing",
  Operations: "Operations",
  PeopleOpsOrHr: "PeopleOpsOrHr",
  ProductManagement: "ProductManagement",
  ProgramOrProjectManagement: "ProgramOrProjectManagement",
  Recruiting: "Recruiting",
  SalesOrBusinessDevelopment: "SalesOrBusinessDevelopment",
  ExecutiveOrBusinessLeader: "ExecutiveOrBusinessLeader",
  VpOrDivisionLeader: "VpOrDivisionLeader",
  DirectorOrDepartmentLeader: "DirectorOrDepartmentLeader",
  Manager: "Manager",
  IndividualContributor: "IndividualContributor",
  InternetSearch: "InternetSearch",
  TeammateInvited: "TeammateInvited",
  TeammateCalendar: "TeammateCalendar",
  TeammateSlackStatus: "TeammateSlackStatus",
  OnlineAdvertisement: "OnlineAdvertisement",
  SocialMedia: "SocialMedia",
  FriendOrFamily: "FriendOrFamily",
  MyMeetingsOnAutopilot: "MyMeetingsOnAutopilot",
  FoundOnline: "FoundOnline",
  TeammateAutopilot: "TeammateAutopilot",
  TeammateFocusTime: "TeammateFocusTime",
  TeammatePersonalCalendar: "TeammatePersonalCalendar",
  TeammateTravelTime: "TeammateTravelTime",
  TeammatePrepTime: "TeammatePrepTime",
  IDoNotKnow: "IDoNotKnow",
  Other: "Other",
};

export const TEAM_SIZE_RESPONSES = [
  {
    responseType: ResponseType.LessThan5,
    responseText: "1 – 4 employees",
  },
  {
    responseType: ResponseType.Between5And9,
    responseText: "5 – 9",
  },
  {
    responseType: ResponseType.Between10And15,
    responseText: "10 – 14",
  },
  {
    responseType: ResponseType.Between15And20,
    responseText: "15 – 20",
  },
  {
    responseType: ResponseType.MoreThan20,
    responseText: "20+",
  },
  {
    responseType: ResponseType.IDoNotWorkOnAnyTeams,
    responseText: `I don't work on any teams at work`,
  },
  {
    responseType: ResponseType.IDoNotKnow,
    responseText: `I don't know`,
  },
];

export const TYPE_OF_WORK_RESPONSES = [
  {
    responseType: ResponseType.Administrative,
    responseText: "Administrative",
  },
  {
    responseType: ResponseType.AccountingOrFinance,
    responseText: "Accounting/Finance",
  },
  {
    responseType: ResponseType.BusinessOwner,
    responseText: "Business Owner",
  },
  {
    responseType: ResponseType.CustomerSupport,
    responseText: "Customer Support",
  },
  {
    responseType: ResponseType.DesignOrUxResearch,
    responseText: "Design/UX Research",
  },
  {
    responseType: ResponseType.SoftwareEngineering,
    responseText: "Engineering (Software)",
  },
  {
    responseType: ResponseType.It,
    responseText: "IT",
  },
  {
    responseType: ResponseType.Legal,
    responseText: "Legal",
  },
  {
    responseType: ResponseType.Marketing,
    responseText: "Marketing",
  },
  {
    responseType: ResponseType.Operations,
    responseText: "Operations",
  },
  {
    responseType: ResponseType.PeopleOpsOrHr,
    responseText: "People Operations/HR",
  },
  {
    responseType: ResponseType.ProductManagement,
    responseText: "Product Management",
  },
  {
    responseType: ResponseType.ProgramOrProjectManagement,
    responseText: "Program/Project Management",
  },
  {
    responseType: ResponseType.Recruiting,
    responseText: "Recruiting",
  },
  {
    responseType: ResponseType.SalesOrBusinessDevelopment,
    responseText: "Sales/Business Development",
  },
  {
    responseType: ResponseType.Other,
    responseText: "Other",
  },
];

export const CURRENT_POSITION_RESPONSES = [
  {
    responseType: ResponseType.ExecutiveOrBusinessLeader,
    responseText: "Executive/Business Leader",
  },
  {
    responseType: ResponseType.DirectorOrDepartmentLeader,
    responseText: "Director/Department Leader",
  },
  {
    responseType: ResponseType.Manager,
    responseText: "Manager",
  },
  {
    responseType: ResponseType.IndividualContributor,
    responseText: "Individual Contributor",
  },
  {
    responseType: ResponseType.Other,
    responseText: "Other",
  },
];

export const HEARD_ABOUT_CLOCKWISE_RESPONSES = [
  {
    responseType: ResponseType.InternetSearch,
    responseText: "Google/internet search",
  },
  {
    responseType: ResponseType.TeammateInvited,
    responseText: "Invited by a coworker",
  },
  {
    responseType: ResponseType.TeammateCalendar,
    responseText: "Saw Clockwise on a coworker's calendar",
  },
  {
    responseType: ResponseType.TeammateSlackStatus,
    responseText: "Saw Clockwise on a coworker's Slack status",
  },
  {
    responseType: ResponseType.OnlineAdvertisement,
    responseText: "Online advertisement",
  },
  {
    responseType: ResponseType.SocialMedia,
    responseText: "Social media",
  },
  {
    responseType: ResponseType.FriendOrFamily,
    responseText: "Friend or family member",
  },
  {
    responseType: ResponseType.MyMeetingsOnAutopilot,
    responseText: "Some of my meetings were put on Autopilot",
  },
  {
    responseType: ResponseType.Other,
    responseText: "Other",
  },
];
